var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import resolvePath from "utils/resolvePath";
import getAuthToken from "utils/getAuthToken";
import { getUserTypePath } from "utils/checkUrl";
// Action
const SET_BILLING_METHOD = 'billing/set_billing_methods';
const STRIPE_CREATE_INTENT = 'billing/stripe_create_intent';
const STRIPE_CREATE_INTENT_SUCCESS = 'billing/stripe_create_intent_success';
const STRIPE_CREATE_INTENT_FAILED = 'billing/stripe_create_intent_failed';
const STRIPE_CHARGE = 'billing/stripe_charge';
const STRIPE_CHARGE_SUCCESS = 'billing/stripe_charge_success';
const STRIPE_CHARGE_FAILED = 'billing/stripe_charge_failed';
const GET_TEACHERS_PAYMENT_PACKAGES = 'billing/get_teachers_payment_packages';
const GET_TEACHERS_PAYMENT_PACKAGES_SUCCESS = 'billing/get_teachers_payment_packages_success';
const GET_TEACHERS_PAYMENT_PACKAGES_FAILED = 'billing/get_teachers_payment_packages_failed';
const GET_STUDENTS_PAYMENT_PACKAGES = 'billing/get_students_payment_packages';
const GET_STUDENTS_PAYMENT_PACKAGES_SUCCESS = 'billing/get_students_payment_packages_success';
const GET_STUDENTS_PAYMENT_PACKAGES_FAILED = 'billing/get_students_payment_packages_failed';
const GET_DEVICE_GATEWAY_BY_PACKAGE = 'billing/get_device_gateway_by_package';
const GET_DEVICE_GATEWAY_BY_PACKAGE_SUCCESS = 'billing/get_device_gateway_by_package_success';
const GET_DEVICE_GATEWAY_BY_PACKAGE_FAILED = 'billing/get_device_gateway_by_package_failed';
const initialState = {
    clientSecret: '',
    billingMethod: 'stripe',
    teachers: {
        paymentPackages: []
    },
    students: {
        paymentPackages: []
    }
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_BILLING_METHOD: {
            return Object.assign(Object.assign({}, state), { billingMethod: action.payload.billingMethod });
        }
        case STRIPE_CREATE_INTENT: {
            return Object.assign(Object.assign({}, state), { clientSecret: '' });
        }
        case STRIPE_CREATE_INTENT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { clientSecret: action.payload.clientSecret });
        }
        case STRIPE_CREATE_INTENT_FAILED: {
            return Object.assign(Object.assign({}, state), { clientSecret: '' });
        }
        case GET_TEACHERS_PAYMENT_PACKAGES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { teachers: {
                    paymentPackages: action.payload.paymentPackages
                } });
        }
        case GET_STUDENTS_PAYMENT_PACKAGES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { students: {
                    paymentPackages: action.payload.paymentPackages
                } });
        }
        case GET_DEVICE_GATEWAY_BY_PACKAGE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { gatewayProduct: action.payload.gatewayProduct });
        }
        case GET_DEVICE_GATEWAY_BY_PACKAGE_FAILED: {
            return Object.assign(Object.assign({}, state), { gatewayProduct: undefined });
        }
        case GET_DEVICE_GATEWAY_BY_PACKAGE: {
            return Object.assign(Object.assign({}, state), { gatewayProduct: undefined });
        }
        default: {
            return state;
        }
    }
};
// Action Creator
export const setBillingMethod = (billingMethod) => ({
    type: SET_BILLING_METHOD,
    payload: {
        billingMethod,
    },
});
export const stripeCreateIntent = () => ({
    type: STRIPE_CREATE_INTENT,
});
export const stripeCreateIntentSuccess = (clientSecret) => ({
    type: STRIPE_CREATE_INTENT_SUCCESS,
    payload: {
        clientSecret,
    },
});
export const stripeCreateIntentFailed = () => ({
    type: STRIPE_CREATE_INTENT_FAILED,
});
export const stripeCreateIntentRequest = (package_id) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(stripeCreateIntent());
    try {
        const authToken = ensureAuthToken();
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        // resolvePath.api は /api/v1 を内部で結合するため、先頭スラッシュ無しの相対パスで指定する。
        const res = yield axios.post(resolvePath.api('billing/stripe/create_intent'), {
            package_id,
        }, config);
        dispatch(stripeCreateIntentSuccess(res.data.client_secret));
    }
    catch (error) {
        dispatch(stripeCreateIntentFailed());
    }
});
export const stripeCharge = () => ({
    type: STRIPE_CHARGE,
});
export const stripeChargeSuccess = () => ({
    type: STRIPE_CHARGE_SUCCESS,
});
export const stripeChargeFailed = () => ({
    type: STRIPE_CHARGE_FAILED,
});
const buildBillingFailureUrl = (userTypePath, failureMessage) => {
    const basePath = resolvePath.page(userTypePath, 'billing/result');
    const params = new URLSearchParams({ status: 'failure' });
    if (failureMessage && failureMessage.length > 0) {
        params.set('message', failureMessage);
    }
    const query = params.toString();
    return query.length > 0 ? `${basePath}?${query}` : basePath;
};
const extractFailureMessage = (error) => {
    var _a;
    if (!axios.isAxiosError(error)) {
        return undefined;
    }
    const data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    const failureMessage = data === null || data === void 0 ? void 0 : data.failure_message;
    return typeof failureMessage === 'string' && failureMessage.length > 0 ? failureMessage : undefined;
};
const extractErrorMessage = (error) => {
    var _a, _b;
    if (error instanceof Error) {
        return error.message;
    }
    if (axios.isAxiosError(error)) {
        const axiosError = error;
        return (((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
            axiosError.message ||
            'Payment request failed. Please try again.');
    }
    return 'Payment request failed. Please try again.';
};
export const stripeChargeRequest = (stripe, card, { packageId, subscription, couponCode, }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    dispatch(stripeCharge());
    const userTypePath = getUserTypePath();
    try {
        const authToken = ensureAuthToken();
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        const confirmEndpoint = resolvePath.api('billing/stripe/confirm'); // second step endpoint for 3DS confirmations
        if (subscription) {
            // サブスクは first step で PaymentMethod を登録し、requires_action が返ったら
            // 追加認証のための client_secret を UI に渡す二段階 3D セキュアフロー。
            const { paymentMethod, error: paymentMethodError } = yield stripe.createPaymentMethod({
                type: 'card',
                card,
            });
            if (paymentMethodError || !paymentMethod) {
                throw new Error((paymentMethodError === null || paymentMethodError === void 0 ? void 0 : paymentMethodError.message) || 'Failed to create payment method');
            }
            const initialResponse = yield axios.post(resolvePath.api('billing/stripe/charge'), {
                package_name: packageId,
                payment_method_id: paymentMethod.id,
                code: couponCode,
            }, config);
            const requiresAction = Boolean((_a = initialResponse.data) === null || _a === void 0 ? void 0 : _a.requires_action);
            const subscriptionId = (_b = initialResponse.data) === null || _b === void 0 ? void 0 : _b.subscription_id;
            if (requiresAction) {
                const clientSecret = (_c = initialResponse.data) === null || _c === void 0 ? void 0 : _c.client_secret;
                if (!clientSecret || !subscriptionId) {
                    throw new Error('Additional authentication is required but client secret is missing');
                }
                // Stripe.js で 3D セキュア認証を実施し、成功後は subscription_id を再送して確定する。
                const confirmation = yield stripe.confirmCardPayment(clientSecret);
                if (confirmation.error) {
                    throw new Error(confirmation.error.message);
                }
                yield axios.post(confirmEndpoint, {
                    package_name: packageId,
                    subscription_id: subscriptionId,
                    code: couponCode,
                }, config);
            }
        }
        else {
            // 単発課金は PaymentIntent の confirmCardPayment が 3D セキュアを内包する。
            const intentResponse = yield axios.post(resolvePath.api('billing/stripe/create_intent'), {
                package_id: Number(packageId),
            }, config);
            const clientSecret = (_d = intentResponse.data) === null || _d === void 0 ? void 0 : _d.client_secret;
            if (!clientSecret) {
                throw new Error('Failed to create payment intent');
            }
            const confirmation = yield stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card,
                },
            });
            if (confirmation.error || !confirmation.paymentIntent) {
                throw new Error(((_e = confirmation.error) === null || _e === void 0 ? void 0 : _e.message) || 'Failed to confirm payment');
            }
            yield axios.post(confirmEndpoint, {
                package_name: packageId,
                payment_intent_id: confirmation.paymentIntent.id,
                code: couponCode,
            }, config);
        }
        dispatch(stripeChargeSuccess());
        window.location.href = resolvePath.page(userTypePath, 'thankyou');
    }
    catch (error) {
        dispatch(stripeChargeFailed());
        const failureMessage = extractFailureMessage(error) || extractErrorMessage(error);
        const failureUrl = buildBillingFailureUrl(userTypePath, failureMessage);
        window.location.href = failureUrl;
        return;
    }
});
// 課金系 API を叩く際に認証トークンが存在することを保証する。
const ensureAuthToken = () => {
    const token = getAuthToken();
    if (!token) {
        throw new Error('Authentication token is missing. Please sign in again.');
    }
    return token;
};
export const getTeachersPaymentPackages = () => ({
    type: GET_TEACHERS_PAYMENT_PACKAGES,
});
export const getTeachersPaymentPackagesSuccess = (paymentPackages) => ({
    type: GET_TEACHERS_PAYMENT_PACKAGES_SUCCESS,
    payload: {
        paymentPackages,
    },
});
export const getTeachersPaymentPackagesFailed = () => ({
    type: GET_TEACHERS_PAYMENT_PACKAGES_FAILED,
});
export const getTeachersPaymentPackagesRequest = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(getTeachersPaymentPackages());
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
        };
        const res = yield axios.get(resolvePath.api('billing/teachers/packages'), config);
        dispatch(getTeachersPaymentPackagesSuccess(res.data));
    }
    catch (error) {
        dispatch(getTeachersPaymentPackagesFailed());
    }
});
export const getStudentsPaymentPackages = () => ({
    type: GET_STUDENTS_PAYMENT_PACKAGES,
});
export const getStudentsPaymentPackagesSuccess = (paymentPackages) => ({
    type: GET_STUDENTS_PAYMENT_PACKAGES_SUCCESS,
    payload: {
        paymentPackages,
    },
});
export const getStudentsPaymentPackagesFailed = () => ({
    type: GET_STUDENTS_PAYMENT_PACKAGES_FAILED,
});
export const getStudentsPaymentPackagesRequest = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(getStudentsPaymentPackages());
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
        };
        const res = yield axios.get(resolvePath.api('billing/students/packages'), config);
        dispatch(getStudentsPaymentPackagesSuccess(res.data));
    }
    catch (error) {
        dispatch(getStudentsPaymentPackagesFailed());
    }
});
export const getDeviceGatewayByPackage = () => ({
    type: GET_DEVICE_GATEWAY_BY_PACKAGE,
});
export const getDeviceGatewayByPackageSuccess = (gatewayProduct) => ({
    type: GET_DEVICE_GATEWAY_BY_PACKAGE_SUCCESS,
    payload: {
        gatewayProduct,
    },
});
export const getDeviceGatewayByPackageFailed = () => ({
    type: GET_DEVICE_GATEWAY_BY_PACKAGE_FAILED,
});
export const getDeviceGatewayByPackageRequest = (gateway, package_id) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(getDeviceGatewayByPackage());
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            },
            params: {
                package_property_id: package_id,
                gateway,
            }
        };
        const res = yield axios.get(resolvePath.api('billing/gateways/find_by_package_and_gateway'), config);
        dispatch(getDeviceGatewayByPackageSuccess(res.data));
    }
    catch (error) {
        dispatch(getDeviceGatewayByPackageFailed());
    }
});
export const createPaypalBilling = function (packageId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!packageId) {
            throw new Error('Invalid package id');
        }
        const CREATE_BILLING_AGREEMENT_URL = 'paypal/agreements';
        const userAuthToken = getAuthToken();
        const config = {
            headers: {
                Authorization: `Bearer ${userAuthToken}`,
            },
        };
        return axios.post(resolvePath.api(CREATE_BILLING_AGREEMENT_URL), {
            package_property_id: packageId,
            client_request: {
                authToken: userAuthToken,
                url: resolvePath.api(CREATE_BILLING_AGREEMENT_URL),
                package_property_id: packageId
            }
        }, config).then(function (response) {
            return response.data.token;
        });
    });
};
export const finalizePaypalBilling = function (packageId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const FINALIZE_BILLING_URL = 'paypal/subscriptions';
        const userAuthToken = getAuthToken();
        const config = {
            headers: {
                Authorization: `Bearer ${userAuthToken}`,
            },
        };
        return axios.post(resolvePath.api(FINALIZE_BILLING_URL), {
            package_property_id: packageId,
            subscription_id: data.subscriptionID,
            client_request: {
                authToken: userAuthToken,
                url: resolvePath.api(FINALIZE_BILLING_URL),
                package_property_id: packageId,
                subscription_id: data.subscriptionID,
            }
        }, config);
    });
};
export function startInAppPurchaseBilling(billingPackage, gatewayProduct, deviceType, userId) {
    if (!billingPackage) {
        throw new Error('Invalid billing package');
    }
    if (!gatewayProduct) {
        throw new Error('Invalid gateway product');
    }
    if (['android', 'ios'].indexOf(deviceType) === -1) {
        throw new Error('Invalid device type');
    }
    if (gatewayProduct.gateway !== deviceType) {
        throw new Error('Invalid gateway product');
    }
    const handlerToCall = deviceType === 'android' ? "sailAndroidApp" : "sailIOSApp";
    const inAppPurchaseData = deviceType === 'android' ? {
        sailAndroid: "googleBilling",
        product_id: gatewayProduct.data_id,
        user_id: userId,
        type: billingPackage.payment_type,
        package_id: billingPackage.id,
    } : {
        sailIOS: "iOSBilling",
        product_id: gatewayProduct.data_id,
        user_id: userId,
        type: billingPackage.payment_type,
        package_id: billingPackage.id,
    };
    window.flutter_inappwebview.callHandler(handlerToCall, JSON.stringify(inAppPurchaseData));
}
